import { useEffect } from 'react';
import { Task } from '@lgg/isomorphic/types/__generated__/graphql';
import { UseRefreshProps } from 'src/hooks/gql/use-refresh.shared';
import { isRefreshDataEventType } from 'src/types/type-guards';

export const useRefreshTask = ({ onRefresh }: UseRefreshProps) => {
  useEffect(() => {
    const handleRefresh = (e, body) => {
      if (isRefreshDataEventType<Task>(body, 'task')) {
        const { id, action, task } = body.entity;
        const title = task?.title;

        onRefresh({ id, action, entityTitle: title });
      }
    };

    window.jQuery(window).on('refreshData', handleRefresh);

    return () => window.jQuery(window).off('refreshData', handleRefresh);
  }, [onRefresh]);
};
